// Aspectos de evaluacion mensual segun la Especificacion Maestra de Beeznz Work.
// Escala 1 a 10 por aspecto.
export interface EvaluationAspect {
  key: string
  label: string
  description: string
}

// Aspectos para evaluar a un COLABORADOR (empresa → colaborador)
export const EVALUATION_ASPECTS: EvaluationAspect[] = [
  { key: 'puntualidad', label: 'Puntualidad', description: 'Cumplimiento de horarios y compromisos de tiempo' },
  { key: 'responsabilidad', label: 'Responsabilidad', description: 'Compromiso con sus tareas y deberes' },
  { key: 'trabajoEnEquipo', label: 'Trabajo en equipo', description: 'Colaboracion con sus companeros' },
  { key: 'liderazgo', label: 'Liderazgo', description: 'Capacidad de guiar e influir positivamente' },
  { key: 'actitud', label: 'Actitud', description: 'Disposicion y energia frente al trabajo' },
  { key: 'productividad', label: 'Productividad', description: 'Resultados y eficiencia en su labor' },
  { key: 'cumplimientoObjetivos', label: 'Cumplimiento de objetivos', description: 'Logro de las metas asignadas' },
  { key: 'comunicacion', label: 'Comunicacion', description: 'Claridad y efectividad al comunicarse' },
  { key: 'adaptabilidad', label: 'Adaptabilidad', description: 'Flexibilidad ante cambios y nuevos retos' },
  { key: 'disciplina', label: 'Disciplina', description: 'Orden, constancia y apego a las normas' },
]

// Aspectos para evaluar a una EMPRESA (colaborador → empresa)
export const COMPANY_EVALUATION_ASPECTS: EvaluationAspect[] = [
  { key: 'pagosTiempo', label: 'Pagos a tiempo', description: 'Cumplimiento puntual con los pagos de salario y prestaciones' },
  { key: 'cumplimientoActividades', label: 'Cumplimiento de actividades', description: 'La empresa cumple con las actividades y funciones acordadas' },
  { key: 'claridadInstrucciones', label: 'Claridad en instrucciones', description: 'Las instrucciones y expectativas son claras y bien comunicadas' },
  { key: 'comunicacionColaborador', label: 'Comunicacion con el colaborador', description: 'La empresa mantiene una comunicacion abierta y respetuosa' },
  { key: 'respetaHorarios', label: 'Respeto a horarios y acuerdos', description: 'Se respetan los horarios, descansos y acuerdos laborales pactados' },
  { key: 'condicionesTrabajo', label: 'Condiciones de trabajo', description: 'El ambiente, herramientas e instalaciones son adecuados' },
  { key: 'solucionProblemas', label: 'Solucion de problemas', description: 'La empresa resuelve incidencias y conflictos de manera efectiva' },
]

export type EvaluationScores = Record<string, number>

export function computeAverage(scores: EvaluationScores, aspects = EVALUATION_ASPECTS): number {
  const values = aspects.map((a) => Number(scores[a.key]) || 0)
  const sum = values.reduce((acc, v) => acc + v, 0)
  return Math.round((sum / aspects.length) * 10) / 10
}
